import { ActionsObservable, combineEpics, StateObservable } from 'redux-observable'
import { concat, from } from 'rxjs'
import { createCompanyActions, CreateCompanyActions } from './create-company.actions'
import { CreateCompanyState } from './create-company.reducer'
import { Deps } from 'src/app.store'
import { DSService } from 'src/services/ds.service'
import { filter, mergeMap } from 'rxjs/operators'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'

type Actions = CreateCompanyActions

interface Action$ extends ActionsObservable<Actions> {}
interface State$ extends StateObservable<CreateCompanyState> {}

const creationCall = (dsService: DSService) => (p: {
  [startFetch]: string
  name: string
  address: string
  postalCode: string
  city: string
  country: string
  phoneNumber: string
  groupingCode: string
  creatorToken: string
}) =>
  concat(
    from(
      dsService
        .createCompany({
          name: p.name,
          address: p.address,
          postalCode: p.postalCode,
          city: p.city,
          country: p.country,
          phoneNumber: p.phoneNumber,
          groupingCode: p.groupingCode,
          creatorToken: p.creatorToken
        })
        .map(_created => createCompanyActions.CreateCompanySuccess({ [stopFetch]: p[startFetch] }))
    )
  )

export const creationEpic = (action$: Action$, _s: State$, deps: Deps) =>
  action$.pipe(
    filter(createCompanyActions.is.CreateCompany),
    mergeMap(creationCall(deps.dsService))
  )

export const createCompanyEpics = combineEpics(creationEpic)



// WEBPACK FOOTER //
// ./src/companies-components/create-company/create-company.epics.ts